import ClassNames from "classnames";
import * as React from "react";

import Styles from "./OrderedList.module.css";

export interface Props {
  listClassName?: string;
  children: React.ReactNode[];
  numberIcons?: boolean;
  inline?: boolean;
}

const OrderedList: React.FC<Props> = props => {
  const { listClassName, children, numberIcons = false, inline } = props;

  return (
    <ol
      className={ClassNames({
        [Styles.orderedlist]: true,
        [Styles.numIcons]: numberIcons,
        [Styles.inline]: inline,
        [listClassName]: listClassName
      })}
    >
      {children}
    </ol>
  );
};

export default OrderedList;
